export const initialTimeSeriesState = {
    tsInfoByIdByHomeIdByTSDBModuleId: {},
    tsIdsByHomeIdByTSDBModuleId: {},
    tsRangeByIdByHomeIdByTSDBModuleId: {},
    tsDataByIdByHomeIdByTSDBModuleIdBySearchParams: {},
    tsRawDataByIdByHomeIdByTSDBModuleIdBySearchParams: {},
    tsCollectionInfoByIdByHomeIdByTSDBModuleId: {},
    tsCollectionIdsByHomeIdByTSDBModuleId: {},
    tsCollectionRangeByIdByHomeIdByTSDBModuleId: {},
    tsCollectionDataByIdByHomeIdByTSDBModuleIdBySearchParams: {},
    tsCollectionRawDataByIdByHomeIdByTSDBModuleIdBySearchParams: {},
};
